import "./BeyondWordsOverride.css";

import { IS_PLAYWRIGHT_TEST } from "@helper/getEnvVariables";
import { useBeyondWordsPlayer } from "@hooks/useBeyondWords/useBeyondWordsPlayer";
import { useIsPlayerReady } from "@hooks/useBeyondWords/useIsPlayerReady";
import { useTooltipOnPlayerReady } from "@hooks/useBeyondWords/useTooltipOnBWPlayerReady";
import { BeyondWordsPlayerProps } from "@typings/BeyondWords.d";

import PlayerTooltip from "./PlayerTooltip";

const BeyondWordsPlayer = (props: BeyondWordsPlayerProps) => {
  const playerRef = useBeyondWordsPlayer(props);
  const playerReady = useIsPlayerReady(playerRef);
  const { showTooltip } = useTooltipOnPlayerReady(playerRef);

  if (IS_PLAYWRIGHT_TEST === "true") return null;

  return (
    <div className="relative mb-6">
      {showTooltip && (
        <div className="absolute bottom-full left-0 mb-1 animate-fade-in">
          <PlayerTooltip />
        </div>
      )}
      <div className="flex flex-col gap-1 items-start w-full">
        <div className="w-full">
          <div ref={playerRef} />
        </div>
        {playerReady && (
          <div className="w-full flex justify-end text-black-700 text-[10px] font-primary font-regular leading-[150%]">
            Generated by AI
          </div>
        )}
      </div>
    </div>
  );
};

export default BeyondWordsPlayer;
